import React from 'react';
import { Callout } from '../../../../ui/Callout';
import { CalloutBlock as CalloutBlockData } from '../../../../../services/admin/cloudAgentTypes';

/** callout → Callout (prose pass-through, no data/source). */
export const CalloutBlockAdapter: React.FC<{ block: CalloutBlockData }> = ({ block }) => (
  <Callout text={block.text} tone={block.tone ?? 'info'} />
);
